import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import { Routes, BrowserRouter, Route } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { CustomTheme } from './theme/theme';
import reportWebVitals from './reportWebVitals';
import Overlay from './components/common/Overlay';
import InvestorsContent from './components/investors/InvestorsContent';
import ProjectInfoMain from './components/projectInfo/ProjectInfoMain';
import Content from './components/Content';
// import ProtectedRoute from './ProtectedRoute';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ChakraProvider theme={CustomTheme}>
    <BrowserRouter>
      <Overlay>
        <Routes>
          <Route path="/" element={<Content />} />
          <Route path="/investorContent" element={<InvestorsContent />} />
          <Route path="/profile" element={<InvestorsContent />} />
          <Route path="/project/:id" element={<ProjectInfoMain />} />
          {/* <Route
            path="/project/:id"
            element={
              <ProtectedRoute>
                <ProjectInfoMain />
              </ProtectedRoute>
            }
          /> */}
        </Routes>
      </Overlay>
    </BrowserRouter>
  </ChakraProvider>,
);

reportWebVitals();
